import { render, staticRenderFns } from "./DefaultView.vue?vue&type=template&id=61f3c8e6&scoped=true&"
import script from "./DefaultView.vue?vue&type=script&lang=js&"
export * from "./DefaultView.vue?vue&type=script&lang=js&"
import style0 from "./DefaultView.vue?vue&type=style&index=0&id=61f3c8e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f3c8e6",
  null
  
)

export default component.exports